import React from 'react';
import withIcon from '../utilities/withIcon';

const IconArrowSpread = () => {
  return (
    <g>
      <path d="m15.6584 7.4678-1.9062-1.9073a.75.75 0 1 0 -1.0605 1.0606l.6345.6348h-6.0568a10.26 10.26 0 0 0 2.3232-3.211l.2152.7422a.7514.7514 0 0 0 .7207.541.74.74 0 0 0 .209-.03.75.75 0 0 0 .5117-.9292l-.751-2.5879a.783.783 0 0 0 -.1367-.2622.7506.7506 0 0 0 -.7959-.251l-2.5869.7544a.75.75 0 0 0 .42 1.44l.9394-.2742c-1.4122 2.9261-2.9222 4.06-5.3281 4.06h-2.1377a.75.75 0 0 0 -.75.75l.0004.002v.0022a.75.75 0 0 0 .75.75h.1038c.006 0 .0109.0034.0169.0034h2.0658c2.376.0159 3.877 1.1516 5.2789 4.0561l-.94-.2739a.75.75 0 0 0 -.42 1.44l2.5869.7544a.7238.7238 0 0 0 .208.03.7579.7579 0 0 0 .59-.2832.767.767 0 0 0 .1348-.26l.751-2.5879a.75.75 0 0 0 -1.4414-.418l-.2152.7423a10.2837 10.2837 0 0 0 -2.3109-3.2h6.0337l-.6234.6235a.75.75 0 1 0 1.0606 1.0611l1.9063-1.9067a.7567.7567 0 0 0 0-1.0654z" />
    </g>
  );
};

export default withIcon(IconArrowSpread);
